import { render, staticRenderFns } from "./TokenComponent.vue?vue&type=template&id=562bd198&scoped=true&lang=pug"
import script from "./TokenComponent.vue?vue&type=script&lang=js"
export * from "./TokenComponent.vue?vue&type=script&lang=js"
import style0 from "./TokenComponent.vue?vue&type=style&index=0&id=562bd198&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562bd198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('562bd198')) {
      api.createRecord('562bd198', component.options)
    } else {
      api.reload('562bd198', component.options)
    }
    module.hot.accept("./TokenComponent.vue?vue&type=template&id=562bd198&scoped=true&lang=pug", function () {
      api.rerender('562bd198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TokenComponent.vue"
export default component.exports